import type { Theme } from 'core'
import { defineTheme, getTheme, zParsePartial } from 'core'
import { ContactFormSettings } from 'core/store/models'
import { z } from 'zod'

const FormData = ContactFormSettings.extend({
  theme: z.custom<Theme>().default(getTheme())
})

type IFormData = z.infer<typeof FormData>

export const useFormTheme = createSharedComposable(() => {
  const defaultStrings = ContactFormSettings.shape.strings.parse({})
  const strings = shallowReactive(defaultStrings)
  const theme = shallowRef(getTheme())

  const { ThemeScope } = defineTheme({
    'header-bg': ['primary', 0.03],
    'player-bar-color': ['neutral', 0.4],
    'player-bar-fill-color': ['primary']
  })

  const Scope = defineComponent((props, ctx) => {
    return () => h(ThemeScope, { theme: theme.value }, () => ctx.slots.default?.())
  })

  function update(data: Partial<IFormData> = {}) {
    const props = zParsePartial(FormData, data)

    Object.assign(strings, props.strings)
    theme.value = props.theme
  }

  /** Handles editor updates */
  useEventListener('message', (event: MessageEvent<{ data?: IFormData }>) => {
    const { success: isValid, data } = FormData.safeParse(event.data.data)

    if (!isValid)
      return

    if (event.origin !== location.origin)
      return Logger.warn('Update data received from third-party origin', event)

    // Update data
    update(data)
  })

  return { Scope, update, strings, theme }
})
